/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import isEmpty from "../validation/is-empty";
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  // LOGIN_REQUEST,
  LOGOUT_REQUEST,
  SET_CURRENT_USER,
  // ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAILURE,
  // SET_CURRENT_USER_DETAIL,
  // UPDATE_USER_DETAIL_SUCCESS,
  // GET_USER_DETAIL,
  // UPDATE_USER_DETAIL
  // RESET_LOGIN,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
} from "../actions/auth/authActionTypes";
import {
  RESEND_EMAIL_SUCCESS,
  RESEND_EMAIL_FAILURE,
  SAVE_REDIRECT,
} from "../actions/actionTypes";
// import { setAuthToken } from '../api/agent';

const initialState = {
  loading: false,
  user: {
    token: "",
    picture: "",
    fullName: "",
  },
  routeToRedirect: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case LOGIN_REQUEST:
    //     return {
    //         loading: true,
    //     }
    case LOGIN_SUCCESS:
      return {
        // loading: false,
        ...state,
        loginSuccess: true,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload,
      };
    case LOGIN_FAILURE:
      return {
        // loading: false,
        ...state,
        loginSuccess: false,
        error: action.errResp.message,
        type: action.errResp.type,
      };
    case SET_CURRENT_USER:
      return {
        // loading: false,
        isAuthenticated: !isEmpty(action.payload),
        user: {
          ...state.user,
          ...action.payload,
        },
        serverResp: action.payload.message,
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: {
          token: "",
          picture: "",
          fullName: "",
        },
        // routeToRedirect:null,
      };

    // case ACTIVATE_USER:
    //   return {
    //     loading: true
    //   }

    case ACTIVATE_USER_SUCCESS:
      return {
        //   loading: false,
        activateUserSuccess: true,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload,
      };

    case ACTIVATE_USER_FAILURE:
      return {
        //   loading: false,
        activateUserSuccess: false,
        error: action.errResp,
      };

    // case RESET_LOGIN:
    //     return {}

    case RESEND_EMAIL_SUCCESS:
      return {
        resendEmailSuccess: true,
        message: action.payload.message,
      };
    case RESEND_EMAIL_FAILURE:
      return {
        resendEmailSuccess: false,
        error: action.errResp.message,
        type: action.errResp.type,
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        // loading: false,
        // success: true,
        isForgotPasswordSuccess: true,
        message: action.payload.message,
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        // loading: false,
        // success: false,
        isForgotPasswordSuccess: false,
        error: action.err.message,
        // type: action.errResp.type,
      };

    case SAVE_REDIRECT:
      return {
        ...state,
        routeToRedirect: action.payload,
      };

    case SIGNUP_SUCCESS:
      return {
        ...state,
        isSignupSuccess: true,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload,
      };

    case SIGNUP_FAILURE:
      return {
        isSignupSuccess: false,
        message: action.errResp.message,
      };

    default:
      return state;
  }
}
